// extracted by mini-css-extract-plugin
export var banner = "_o8-0";
export var settingRow = "_o8-2";
export var titleIcon = "_o8-1";